







































import BaseComponent from '@/components/base-component.vue';
import UiChangeCurrentBusinessUnit from '@/components/UI/change-current-businessunit.vue';
import UiChangeCurrentClient from '@/components/UI/change-current-client.vue';
import router from '@/routes';
import {
  getLocalBusinessUnit, getLocalClient, getLocalUser, getLocalUserObj, getRedirectEmpresaAfterLogin, getSelectedBusinessUnitFromLocal, getSelectedClientFromLocal, removeRedirectEmpresaAfterLogin
} from '@/services/session-data';
import * as UpdateUserData$ from '@/subjects/update-user-data';
import Component from 'vue-class-component';

import * as service from '@/services/webauthn';
import { ACCESS_TYPE_GLOBAL } from '@/settings/consts/users';
import PhonenumberValidationDialog from '@/components/phonenumber-validation/phonenumber-valid-dialog.vue';

@Component({
  components: { UiChangeCurrentClient, UiChangeCurrentBusinessUnit, PhonenumberValidationDialog },
})
export default class UserToolbarMenu extends BaseComponent {
  public user: any = {};
  public selectedClientNovo: any = {};
  public selectedBusinessUnitNovo: any = {};

  public selectedClient: any = {
    nome: '',
    imagem: '',
  };

  public selectedBusinessUnit: any = {
    razaoSocial: '',
    imagem: '',
  };

  public showChangeClientModal: boolean = false;
  public showChangeBusinessUnitModal: boolean = false;
  public userMenu: boolean = false;

  public empresa: any = null;
  public unidade: any = null;

  public showCellphoneValidation = false;

  public mounted(): void {
    this.getCurrentUser();
    this.getLocalBusinessUnitNovo();
    this.getLocalClientNovo();
    
    // Se for usuário normal (não o Administrador Global)... mostra popups
    if (!this.isGlobal()) {
      // Mostra a popup para seleção de Empresa (BusinessUnit)
      if (this.selectedBusinessUnitNovo === null) {
        if(this.user && this.user.listaEmpresas && !this.isMultiEmpresa()){
        // Seleciona a única empresa que tem (sem mostrar a tela);
         this.empresa = this.user.listaEmpresas[0];
        } if (this.user && this.user.listaEmpresas && getRedirectEmpresaAfterLogin()){
          //seleciona a empresa do redirect after login
          this.empresa = this.user.listaEmpresas.filter(e=> e.id == getRedirectEmpresaAfterLogin())[0];
          removeRedirectEmpresaAfterLogin();
        } else
          this.showChangeBusinessUnitModal = true;
      } else {
        // Mostra a popup para seleção de Unidade (Cliente)
        if (this.selectedClientNovo == null && !this.isEmede() && !this.isDoctor() && this.isMultiUnidade()) {
          this.showChangeClientModal = true;
        } else {
          // Seleciona a única unidade que tem (sem mostrar a tela); 
          if (this.selectedClientNovo === null && !this.isEmede() && !this.isDoctor() && this.user.listaUnidades) {
            this.unidade = this.user.listaUnidades[0];
          }
        }
      }
      this.getCurrentBusinessUnit();
      this.getCurrentClient();
    }
    this.checkRegisterFingerprint();
    this.checkShowCellphoneValidation();
  }

  public redirect(path) {
    router.push(path);
  }

  public onClientClick(clientUnit: any) {
    this.closeModalClient();
    this.userMenu = false;
    this.selectedClient = clientUnit;
    this.$forceUpdate();
  }

  public onBusinessUnitClick(businessUnit: any) {
    this.selectedBusinessUnit = businessUnit;
    this.selectedClient = null;
    this.showChangeClientModal = true;
    this.getCurrentClient();
  }

  public closeModalBusinessUnit(): void {
    this.showChangeBusinessUnitModal = false;
  }

  public openModalBusinessUnit() {
    if (this.isGlobal() || !this.isMultiEmpresa()) {
      return
    }
    setTimeout(() => {
      this.showChangeBusinessUnitModal = true;      
    }, 100);
  }

  public closeModalClient(): void {
    this.showChangeClientModal = false;
  }

  public openModalClient() {
    setTimeout(() => {
      this.showChangeClientModal = true;      
    }, 100);
  }

  public isGlobal(): boolean {
    return this.user.tipoAcesso === ACCESS_TYPE_GLOBAL;
  }

  // Utilizada para definir se mostra ou não a popup para selecionar Empresa
  public isMultiEmpresa(): boolean {
    if (this.user.listaEmpresas !== undefined)
      return this.user.listaEmpresas.length > 1;
    else
      return false
  }
  // Utilizada para definir se mostra ou não a popup para selecionar cliente / unidade
  public isMultiUnidade(): boolean {
    if (this.user.listaUnidades !== undefined)    
      return this.user.listaUnidades.length > 1;
    else
      return false;
  }

  private getCurrentUser(): void {
    getLocalUser().subscribe((data) => {
      if (!!data) {
        this.user = data;
      }
    });

    UpdateUserData$.get().subscribe((data) => {
      if (!!data) {
        this.user = data;
      }
    });
  }

  private getLocalClientNovo(): void {
    this.selectedClientNovo = getLocalClient();
  }

  private getLocalBusinessUnitNovo(): void {
    this.selectedBusinessUnitNovo = getLocalBusinessUnit();
  }

  private getCurrentClient(): void {
    getSelectedClientFromLocal().subscribe((data) => {
      if (!!data) {
        this.selectedClient = data;
      }
    });
  }

  private getCurrentBusinessUnit(): void {
    getSelectedBusinessUnitFromLocal().subscribe((data) => {
      if (!!data) {
        this.selectedBusinessUnit = data;
      }
    });
  }

  allowRegisterFingerprint = false;

  checkRegisterFingerprint() {
    service.isFingerprintAvailable().then(r => {
      this.allowRegisterFingerprint = r && !service.isFingerprintRegistered();
    });
  }


  private registerFingerprint() {
    this.loader.start("Processando ...");
    service.registerFingerprint().then(r => {
      this.toast.show(r, 'success');
      this.loader.stop();
    }).catch(error => {
      this.loader.stop();
      this.toast.show("Não foi possível cadastrar a biometria", "error");
    }) ;
  }

  private checkShowCellphoneValidation() {
    if (this.showChangeBusinessUnitModal || this.showChangeClientModal) {
      return false;
    }

    if (!getLocalUserObj().validarCelular) {
      return;
    }
    this.showCellphoneValidation = true;
  }

  private onCloseCellphoneValidation() {
    this.showCellphoneValidation = false;
  }
}
